import { TAuthConfig } from 'react-oauth2-code-pkce';

const clientId = import.meta.env.VITE_OAUTH_CLIENT_ID;
const authorizeEndpoint = import.meta.env.VITE_OAUTH_AUTH_ENDPOINT;
const tokenEndpoint = import.meta.env.VITE_OAUTH_TOKEN_ENDPOINT;

export const resetPasswordUrl = import.meta.env.VITE_RESET_PASSWORD_URL!;

export const AuthConfig: TAuthConfig = {
  clientId: clientId!,
  authorizationEndpoint: authorizeEndpoint!,
  tokenEndpoint: tokenEndpoint!,
  // /auth/callback is the MSAL redirect bridge page
  redirectUri: window.location.origin + '/auth/oauth-callback',
  autoLogin: false,
};
